export default __webpack_public_path__ + "static/5-tips-for-travelling-around-europe-in-winter-88e2476d044464d2b9e55a15df236a0a.jpg";